export default {
  namespaced: true,
  state: {
    currentClassId: null
  },
  mutations: {
    setCurrentClassId(state, classId) {
      state.currentClassId = classId
    }
  },
  actions: {
    setCurrent({ commit }, id) {
      commit('setCurrentClassId', id)
    },
    async fetchForStudent({ dispatch }) {
      const customClasses = await this._vm.$axios.get(
        'api/custom-classes/students/custom-classes',
        {
          params: {
            module: 'student'
          }
        }
      )

      dispatch(
        'entities/classes/insertOrUpdate',
        { data: customClasses },
        { root: true }
      )
    },
    async fetchForTeacher({ dispatch }) {
      const customClasses = await this._vm.$axios.get(
        'api/custom-classes/classes',
        {
          params: {
            module: 'teacher'
          }
        }
      )
      dispatch(
        'entities/classes/insertOrUpdate',
        { data: customClasses },
        { root: true }
      )
    },
    async create({ dispatch }, { payload }) {
      try {
        const customClass = await this._vm.$axios.post(
          'api/custom-classes/classes',
          payload
        )
        dispatch(
          'entities/classes/insertOrUpdate',
          { data: customClass },
          { root: true }
        )
        return customClass
      } catch (error) {
        throw error
      }
    },
    async updateClass({ dispatch }, { payload }) {
      try {
        const customClass = await this._vm.$axios.patch(
          `api/custom-classes/classes/${payload.id}`,
          payload
        )

        dispatch(
          'entities/classes/update',
          { data: customClass },
          { root: true }
        )
        return customClass
      } catch (error) {
        throw error
      }
    },
    async addMessage({ dispatch }, { payload }) {
      try {
        const customClass = await this._vm.$axios.post(
          `api/custom-classes/${payload.custom_class_id}/messages`,
          payload
        )

        dispatch(
          'entities/classes/update',
          { data: customClass },
          { root: true }
        )
        return customClass
      } catch (error) {
        throw error
      }
    },
    async updateMessage({ dispatch }, { payload, messageId }) {
      try {
        const customClass = await this._vm.$axios.patch(
          `api/custom-classes/${payload.custom_class_id}/messages/${messageId}`,
          payload
        )

        dispatch(
          'entities/classes/update',
          { data: customClass },
          { root: true }
        )
        return customClass
      } catch (error) {
        throw error
      }
    },
    async deleteMessage({ dispatch }, { payload, messageId }) {
      try {
        const customClass = await this._vm.$axios.delete(
          `api/custom-classes/${payload.custom_class_id}/messages/${messageId}?module=${payload.module}`,
          payload
        )

        dispatch(
          'entities/classes/update',
          { data: customClass },
          { root: true }
        )
        return customClass
      } catch (error) {
        throw error
      }
    },
    async destroy({ dispatch }, { customClassId, mod }) {
      await this._vm.$axios.delete(
        `api/custom-classes/classes/${customClassId}`,
        { data: { module: mod } }
      )
      dispatch(
        'entities/classes/delete',
        { where: customClassId },
        { root: true }
      )
    },
    async toggleLessons({ dispatch }, { payload }) {
      try {
        const customClass = await this._vm.$axios.put(
          `api/custom-classes/${payload.custom_class_id}/lessons?module=teacher`,
          payload
        )
        dispatch(
          'entities/classes/insertOrUpdate',
          { data: customClass },
          { root: true }
        )

        return customClass
      } catch (error) {
        throw error
      }
    }
  },
  getters: {
    currentClassId: state => state.currentClassId
  }
}
